import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import { Form } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import axios from 'axios';
import {
    useAuth

} from '../../contexts/authContext';
import { InputGroup } from 'react-bootstrap';
import { updateProfile } from "firebase/auth";
import { getPortalUrl } from "./../stripe/stripePayment.ts";
import { app, auth } from '../../firebase/firebase';
import { updatePassword } from "firebase/auth";
import { reauthenticateWithCredential } from 'firebase/auth';
import { EmailAuthProvider } from 'firebase/auth';
import { v4 as uuidv4 } from 'uuid';
import { faQuestionCircle, faMinus, faPlus, faCircle, faEye, faEyeSlash, faCopy, faUser, faKey, faCar, faCreditCard } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { db } from '../../firebase/firebase';
import { collection, getDocs, doc, getDoc, setDoc, deleteDoc } from 'firebase/firestore';

// Modern styling for the modal
const modalStyles = {
    header: {
        background: 'linear-gradient(135deg, var(--gf-primary-400, #FD7218) 0%, var(--gf-primary-500, #E65A00) 100%)',
        color: 'white',
        borderBottom: 'none',
        padding: '1.25rem 1.5rem',
    },
    headerTitle: {
        fontWeight: '600',
        fontSize: '1.25rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
    },
    body: {
        padding: '0',
        maxHeight: 'calc(100vh - 200px)',
        overflowY: 'auto',
    },
    section: {
        padding: '1.25rem 1.5rem',
        borderBottom: '1px solid var(--gf-border-color, #E5E7EB)',
    },
    sectionHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        marginBottom: '1rem',
        color: 'var(--gf-secondary-600, #3A3F47)',
        fontWeight: '600',
        fontSize: '1rem',
    },
    sectionIcon: {
        color: 'var(--gf-primary-400, #FD7218)',
        fontSize: '1rem',
    },
    label: {
        fontSize: '0.875rem',
        fontWeight: '500',
        color: 'var(--gf-secondary-600, #3A3F47)',
        marginBottom: '0.375rem',
        display: 'block',
    },
    input: {
        borderRadius: '8px',
        border: '1px solid var(--gf-border-color, #E5E7EB)',
        padding: '0.625rem 0.875rem',
        fontSize: '0.875rem',
        transition: 'border-color 0.2s, box-shadow 0.2s',
    },
    inputFocus: {
        borderColor: 'var(--gf-primary-400, #FD7218)',
        boxShadow: '0 0 0 3px rgba(253, 114, 24, 0.15)',
    },
    primaryButton: {
        background: 'var(--gf-primary-400, #FD7218)',
        border: 'none',
        borderRadius: '8px',
        padding: '0.625rem 1.25rem',
        fontWeight: '500',
        fontSize: '0.875rem',
        transition: 'background-color 0.2s, transform 0.1s',
    },
    secondaryButton: {
        background: 'var(--gf-secondary-100, #E5E7EA)',
        color: 'var(--gf-secondary-600, #3A3F47)',
        border: 'none',
        borderRadius: '8px',
        padding: '0.625rem 1.25rem',
        fontWeight: '500',
        fontSize: '0.875rem',
    },
    dangerButton: {
        background: '#DC2626',
        border: 'none',
        borderRadius: '6px',
        padding: '0.5rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    successButton: {
        background: '#059669',
        border: 'none',
        borderRadius: '6px',
        padding: '0.5rem',
    },
    warningButton: {
        background: '#D97706',
        border: 'none',
        borderRadius: '8px',
        padding: '0.625rem 1.25rem',
        fontWeight: '500',
        fontSize: '0.875rem',
        color: 'white',
    },
    tokenCard: {
        background: 'var(--gf-secondary-50, #F5F6F7)',
        borderRadius: '8px',
        padding: '1rem',
        border: '1px solid var(--gf-border-color, #E5E7EB)',
    },
    footer: {
        borderTop: '1px solid var(--gf-border-color, #E5E7EB)',
        padding: '1rem 1.5rem',
        background: 'var(--gf-secondary-50, #F5F6F7)',
    },
};

const PasswordUpdater = ({ email }) => {

    const [password, setPassword] = useState('')
    const [confirmPassword, setconfirmPassword] = useState('')
    const [currentPassword, setCurrentPassword] = useState('')

    const [passwordMatch, setPasswordMatch] = useState(true);

    useEffect(() => {
        if (password === confirmPassword) {
            setPasswordMatch(true);
        } else if (password !== confirmPassword) {
            setPasswordMatch(false)
        }

    }, [password, confirmPassword])


    const updatePasswordForm = (e) => {
        e.preventDefault();
        const user = auth.currentUser;

        const credential = EmailAuthProvider.credential(email, currentPassword);

        reauthenticateWithCredential(user, credential)
            .then(() => {
                updatePassword(user, password).then(() => {
                    alert("Successfully Changed Password")
                    setPassword('')
                    setconfirmPassword('')
                    setCurrentPassword('')
                }).catch((error) => {
                    alert(error)
                });
            }).catch(error => {
                alert("Current Password Incorrect")
            })


    }


    return (
        <form onSubmit={(e) => updatePasswordForm(e)} noValidate>
            <Row className="g-3">
                <Col xs={12}>
                    <label style={modalStyles.label}>Current Password</label>
                    <input
                        type="password"
                        autoComplete='current-password'
                        required
                        value={currentPassword}
                        onChange={(e) => { setCurrentPassword(e.target.value) }}
                        className="form-control"
                        style={modalStyles.input}
                        placeholder="Enter current password"
                    />
                </Col>
                <Col xs={12} md={6}>
                    <label style={modalStyles.label}>New Password</label>
                    <input
                        type="password"
                        autoComplete='new-password'
                        required
                        value={password}
                        onChange={(e) => { setPassword(e.target.value) }}
                        className="form-control"
                        style={modalStyles.input}
                        placeholder="Enter new password"
                    />
                </Col>
                <Col xs={12} md={6}>
                    <label style={modalStyles.label}>Confirm New Password</label>
                    <input
                        type="password"
                        autoComplete='new-password'
                        required
                        value={confirmPassword}
                        onChange={(e) => { setconfirmPassword(e.target.value) }}
                        className={`form-control ${passwordMatch ? "" : "is-invalid"}`}
                        style={modalStyles.input}
                        placeholder="Repeat new password"
                    />
                    <div className="invalid-feedback">
                        Passwords don't match
                    </div>
                </Col>
                <Col xs={12}>
                    <button
                        className="btn btn-primary"
                        style={modalStyles.primaryButton}
                        type="submit"
                        disabled={!passwordMatch || !currentPassword || !password}
                    >
                        Change Password
                    </button>
                </Col>
            </Row>
        </form>
    );
}


export const UserProfile = (props) => {

    const { currentUser } = useAuth()
    const [displayName, setDisplayName] = useState(currentUser.displayName)
    const [address, setAddress] = useState();
    const [minersRightNo, setMinersRightNo] = useState();
    const [phoneNo, setPhoneNo] = useState();

    const [vehicles, setVehicles] = useState([]);

    if (currentUser !== null) {
        // The user object has basic properties such as display name, email, etc.
        const displayName = currentUser.displayName;
        const email = currentUser.email;
        const photoURL = currentUser.photoURL;
        const emailVerified = currentUser.emailVerified;
    }

    useEffect(e => {



        //currentUser.getIdToken().then(e => {
        // })


        //onsole.log(currentUser)
        // get the extra user data

        const dataStorageLocation = doc(
            db,
            "user_info",
            currentUser?.uid

        );


        getDoc(dataStorageLocation).then(userData => {
            setMinersRightNo(userData.data().minersrightno)
            setAddress(userData.data().address)
            setPhoneNo(userData.data().phoneno)

        })



        const veichleUserStorage = collection(
            db,
            "user_info",
            currentUser?.uid,
            "vehicles"
        );

        const placemarks = getDocs(veichleUserStorage).then(vehicles => {
            const allStoredVehicles = [];
            vehicles.forEach(vehicle => {
                allStoredVehicles.push(vehicle.data());
            })


            if (allStoredVehicles.length === 0) {
                allStoredVehicles.push({
                    id: uuidv4()
                })
            }
            setVehicles(allStoredVehicles);

        })



    }, [])


    const addVehicleEntry = () => {
        setVehicles([...vehicles, { id: uuidv4() }]);
    }


    const setVehicleMake = (id, make) => {
        setVehicles([...vehicles.map(vehicle => {
            if (vehicle.id === id) {
                vehicle.make = make;
            }
            return vehicle;
        })])
    }

    const setVehicleModel = (id, model) => {
        setVehicles([...vehicles.map(vehicle => {
            if (vehicle.id === id) {
                vehicle.model = model;
            }
            return vehicle;
        })])
    }

    const setVehicleRego = (id, rego) => {
        setVehicles([...vehicles.map(vehicle => {
            if (vehicle.id === id) {
                vehicle.rego = rego;
            }
            return vehicle;
        })])
    }

    const removeVehicle = (id) => {
        setVehicles([...vehicles.filter(vehicle =>
            vehicle.id !== id
        )])

        const veichleUserStorage = doc(
            db,
            "user_info",
            currentUser?.uid,
            "vehicles",
            id
        );

        deleteDoc(veichleUserStorage);


    }

    const profileSummary = (
        <Row className="g-3">
            <Col xs={12} md={6}>
                <label style={modalStyles.label} htmlFor="validationCustom01">Full Name</label>
                <input
                    type="text"
                    name="fullname"
                    className="form-control"
                    style={modalStyles.input}
                    id="validationCustom01"
                    placeholder="Full Name"
                    defaultValue={displayName}
                    required
                />
            </Col>
            <Col xs={12} md={6}>
                <label style={modalStyles.label} htmlFor="validationCustom02">Email</label>
                <input
                    type="text"
                    className="form-control"
                    style={{ ...modalStyles.input, backgroundColor: 'var(--gf-secondary-50, #F5F6F7)' }}
                    id="validationCustom02"
                    value={currentUser.email}
                    disabled
                />
            </Col>
        </Row>
    );

    const section40eDetails = (
        <>
            <Row className="g-3 mb-3">
                <Col xs={12}>
                    <label style={modalStyles.label} htmlFor="addressField">Address</label>
                    <input
                        type="text"
                        name="address"
                        defaultValue={address}
                        className="form-control"
                        style={modalStyles.input}
                        id="addressField"
                        placeholder="Enter your address"
                    />
                </Col>
                <Col xs={12} md={6}>
                    <label style={modalStyles.label} htmlFor="phoneNo">Telephone No.</label>
                    <input
                        type="text"
                        name="phoneno"
                        defaultValue={phoneNo}
                        className="form-control"
                        style={modalStyles.input}
                        id="phoneNo"
                        placeholder="e.g., 0400 000 000"
                    />
                </Col>
                <Col xs={12} md={6}>
                    <label style={modalStyles.label} htmlFor="minersNo">Miners Right No.</label>
                    <input
                        type="text"
                        name="minersrightno"
                        defaultValue={minersRightNo}
                        className="form-control"
                        style={modalStyles.input}
                        id="minersNo"
                        placeholder="Enter miners right number"
                    />
                </Col>
            </Row>

            {/* Vehicles Section */}
            <div style={{ marginTop: '1rem' }}>
                <div style={{ ...modalStyles.sectionHeader, marginBottom: '0.75rem', fontSize: '0.875rem' }}>
                    <FontAwesomeIcon icon={faCar} style={{ ...modalStyles.sectionIcon, fontSize: '0.875rem' }} />
                    <span>Vehicles</span>
                </div>
                <p style={{ fontSize: '0.8125rem', color: 'var(--gf-secondary-500, #6B7280)', marginBottom: '0.75rem' }}>
                    Make, Model and Registration Number of vehicles to be used.
                </p>

                {vehicles.map((vehicle, index) => (
                    <Row key={vehicle.id} className="g-2 mb-2 align-items-end">
                        <Col xs={12} sm={3}>
                            {index === 0 && <label style={{ ...modalStyles.label, fontSize: '0.75rem' }}>Make</label>}
                            <input
                                type="text"
                                name="vehicleMake"
                                defaultValue={vehicle.make}
                                onChange={e => { setVehicleMake(vehicle.id, e.target.value) }}
                                className="form-control form-control-sm"
                                style={{ ...modalStyles.input, padding: '0.5rem 0.75rem' }}
                                placeholder="Toyota"
                            />
                        </Col>
                        <Col xs={12} sm={4}>
                            {index === 0 && <label style={{ ...modalStyles.label, fontSize: '0.75rem' }}>Model</label>}
                            <input
                                type="text"
                                name="vehicleModel"
                                defaultValue={vehicle.model}
                                onChange={e => { setVehicleModel(vehicle.id, e.target.value) }}
                                className="form-control form-control-sm"
                                style={{ ...modalStyles.input, padding: '0.5rem 0.75rem' }}
                                placeholder="Landcruiser"
                            />
                        </Col>
                        <Col xs={10} sm={4}>
                            {index === 0 && <label style={{ ...modalStyles.label, fontSize: '0.75rem' }}>Registration</label>}
                            <input
                                type="text"
                                name="vehicleRego"
                                defaultValue={vehicle.rego}
                                onChange={e => { setVehicleRego(vehicle.id, e.target.value) }}
                                className="form-control form-control-sm"
                                style={{ ...modalStyles.input, padding: '0.5rem 0.75rem' }}
                                placeholder="ABC-123"
                            />
                        </Col>
                        <Col xs={2} sm={1}>
                            <button
                                onClick={e => { e.preventDefault(); removeVehicle(vehicle.id); }}
                                className='btn btn-sm'
                                style={modalStyles.dangerButton}
                                title="Remove vehicle"
                            >
                                <FontAwesomeIcon icon={faMinus} style={{ color: 'white' }} />
                            </button>
                        </Col>
                    </Row>
                ))}

                <button
                    onClick={(e) => { e.preventDefault(); addVehicleEntry(); }}
                    className='btn btn-sm'
                    style={{ ...modalStyles.successButton, marginTop: '0.5rem' }}
                >
                    <FontAwesomeIcon icon={faPlus} style={{ color: 'white', marginRight: '0.375rem' }} />
                    <span style={{ color: 'white' }}>Add Vehicle</span>
                </button>
            </div>
        </>
    )



    const updateProfileSummary = (e) => {
        e.preventDefault()

        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData.entries());


        if (data.fullname !== currentUser.displayName && currentUser) {
            updateProfile(auth.currentUser, {
                displayName: data.fullname, photoURL: ""
            }).then(() => {
                // Profile updated!
                setDisplayName(data.fullname);
                // set address


                alert("Success")
            }).catch((error) => {
                // An error occurred
                // ...
                alert(error);
            });
        }



        setDoc(doc(db, "user_info", currentUser.uid), {
            address: data.address,
            phoneno: data.phoneno,
            minersrightno: data.minersrightno
        }).then(() => {
            alert("Success")
            setMinersRightNo(data.minersrightno)
            setAddress(data.address)
            setPhoneNo(data.phoneno)

        }).catch((error) => {
            // An error occurred
            // ...
            alert(error);
        });


        vehicles.forEach(vehicle => {


            const veichleUserStorage = doc(
                db,
                "user_info",
                currentUser?.uid,
                "vehicles",
                vehicle.id
            );

            const docRef = setDoc(veichleUserStorage,
                vehicle
            );
        })




    }

    const [showPass, setShowPass] = useState(false);
    const clickHandler = () => {
        setShowPass((prev) => !prev);
    };

    const [subscriptionLoading, setSubscriptionLoading] = useState(false);

    const manageSubscription = async () => {
        setSubscriptionLoading(true);
        try {
            const portalUrl = await getPortalUrl(app);
            window.location.assign(portalUrl);
        } catch (error) {
            setSubscriptionLoading(false);
            alert("Failed to load subscription portal. Please try again.");
        }
    };

    // 40e details -> https://www.dmp.wa.gov.au/Documents/Minerals/Minerals_Section_40E_Permit_System.pdf

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="gf-account-modal"
        >
            <Modal.Header closeButton style={modalStyles.header}>
                <Modal.Title id="contained-modal-title-vcenter" style={modalStyles.headerTitle}>
                    <FontAwesomeIcon icon={faUser} />
                    Account Settings
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={modalStyles.body}>

                {/* Trilobite Export Token - Moved to top */}
                <div style={modalStyles.section}>
                    <div style={modalStyles.sectionHeader}>
                        <FontAwesomeIcon icon={faKey} style={modalStyles.sectionIcon} />
                        <span>Trilobite Export Token</span>
                    </div>
                    <div style={modalStyles.tokenCard}>
                        <p style={{ fontSize: '0.8125rem', color: 'var(--gf-secondary-500, #6B7280)', marginBottom: '0.75rem' }}>
                            Use this token to export data to the Trilobite mobile app.
                        </p>
                        <InputGroup>
                            <Form.Control
                                type={showPass ? "text" : "password"}
                                name="token"
                                aria-label="Trilobite Export Token"
                                defaultValue={currentUser.uid}
                                aria-describedby="token-input"
                                readOnly
                                style={{
                                    ...modalStyles.input,
                                    borderTopRightRadius: 0,
                                    borderBottomRightRadius: 0,
                                    backgroundColor: 'white',
                                    fontFamily: 'monospace',
                                    fontSize: '0.8125rem',
                                }}
                            />
                            <Button
                                variant="outline-secondary"
                                onClick={clickHandler}
                                title={showPass ? "Hide token" : "Show token"}
                                style={{ borderColor: 'var(--gf-border-color, #E5E7EB)' }}
                            >
                                <FontAwesomeIcon icon={showPass ? faEyeSlash : faEye} />
                            </Button>
                            <Button
                                variant="outline-secondary"
                                onClick={() => {
                                    navigator.clipboard.writeText(currentUser.uid);
                                    alert("Token copied to clipboard!");
                                }}
                                title="Copy token"
                                style={{ borderColor: 'var(--gf-border-color, #E5E7EB)' }}
                            >
                                <FontAwesomeIcon icon={faCopy} />
                            </Button>
                        </InputGroup>
                    </div>
                </div>

                {/* General Profile Section */}
                <div style={modalStyles.section}>
                    <div style={modalStyles.sectionHeader}>
                        <FontAwesomeIcon icon={faUser} style={modalStyles.sectionIcon} />
                        <span>General Information</span>
                    </div>
                    <form onSubmit={(e) => updateProfileSummary(e)} noValidate>
                        {profileSummary}

                        {/* Section 40E Details */}
                        <div style={{ marginTop: '1.5rem' }}>
                            <div style={{ ...modalStyles.sectionHeader, marginBottom: '1rem' }}>
                                <span style={{ fontSize: '0.875rem', color: 'var(--gf-secondary-500, #6B7280)' }}>
                                    Section 40E Required Details
                                </span>
                            </div>
                            {section40eDetails}
                        </div>

                        <div style={{ marginTop: '1.25rem' }}>
                            <button
                                className="btn btn-primary"
                                style={modalStyles.primaryButton}
                                type="submit"
                            >
                                Save Profile
                            </button>
                        </div>
                    </form>
                </div>

                {/* Change Password Section */}
                <div style={modalStyles.section}>
                    <div style={modalStyles.sectionHeader}>
                        <FontAwesomeIcon icon={faKey} style={modalStyles.sectionIcon} />
                        <span>Change Password</span>
                    </div>
                    <PasswordUpdater email={currentUser.email} />
                </div>

                {/* Subscription Section */}
                <div style={{ ...modalStyles.section, borderBottom: 'none' }}>
                    <div style={modalStyles.sectionHeader}>
                        <FontAwesomeIcon icon={faCreditCard} style={modalStyles.sectionIcon} />
                        <span>Subscription</span>
                    </div>
                    <p style={{ fontSize: '0.8125rem', color: 'var(--gf-secondary-500, #6B7280)', marginBottom: '0.75rem' }}>
                        Manage your subscription, update payment methods, or view billing history.
                    </p>
                    <button
                        className="btn"
                        style={modalStyles.warningButton}
                        onClick={() => manageSubscription()}
                        disabled={subscriptionLoading}
                    >
                        {subscriptionLoading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Redirecting...
                            </>
                        ) : (
                            'Manage Subscription'
                        )}
                    </button>
                </div>

            </Modal.Body>

            <Modal.Footer style={modalStyles.footer}>
                <Button
                    variant="secondary"
                    style={modalStyles.secondaryButton}
                    onClick={props.onHide}
                >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}